import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ProductScope, ProductService, isNotUndefined } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CustomOhgarBannerAndProductsData } from './custom-ohgar-banner-and-products.model';

@Component({
  selector: 'app-custom-ohgar-banner-and-products',
  templateUrl: './custom-ohgar-banner-and-products.component.html',
  styleUrls: ['./custom-ohgar-banner-and-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomOhgarBannerAndProductsComponent {
  animation = 'swipe';
  protected readonly PRODUCT_SCOPE = ProductScope.LIST;

  constructor(
    public component: CmsComponentData<CustomOhgarBannerAndProductsData>,
    protected productService: ProductService,
    protected breakpointService: BreakpointService,
    protected cd: ChangeDetectorRef,
  ) { }

  data$ = this.component.data$.pipe(map(component => component));

  items$: Observable<any> = this.data$.pipe(
    map((data) =>
        (data.products.productCodes?.trim().split(' ') ?? []).map((code) =>
          this.productService.get(code, this.PRODUCT_SCOPE),
        ),
      map(filter(isNotUndefined)),
    ),
  );

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }
}
